import React from "react"
import ReactTooltip from "react-tooltip"
import Icon from "../../Icon/Icon"
import Button from "../../Button/Button"
import {useModal} from "react-modal-hook"
import {JwksInfoModal} from "../JwksInfoModal/JwksInfoModal"
import {JWTProviders} from "../../../resources/orgSettings"
import * as Yup from "yup"
import TextField from "../TextField/TextField"

const jwksPathSchema = Yup.string()
	.required("JWKS path is required")
	.matches(
		/^https:\/\/[A-Za-z0-9\-\.]+\/v1(?:\/b2b)?\/sessions\/jwks\/([A-Za-z0-9\-\.]*)$/,
		"Must be a valid Stytch JWKS URL: 'https://[domain]/v1/sessions/jwks/PROJECT_ID' or 'https://[domain]/v1/b2b/sessions/jwks/PROJECT_ID'"
	)

const issuerSchema = Yup.string().required("JWT Issuer is required")

export default function StytchFileds() {
	const [showJwksInfoModal, hideJwksInfoModal] = useModal(() => (
		<JwksInfoModal close={hideJwksInfoModal} provider={JWTProviders.Stytch} />
	))

	return (
		<fieldset className="jwt-fields">
			<TextField
				name="jwksPath"
				label="JWKS Path"
				placeholder="https://api.stytch.com/v1/sessions/jwks/PROJECT_ID or custom domain"
				validationSchema={jwksPathSchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<Button type="button" className="jwks-button" onClick={showJwksInfoModal}>
							How to find my JWKS
						</Button>
					</>
				}
			/>
			<TextField
				name="issuer"
				label="Issuer"
				placeholder="https://stytch.com/PROJECT_ID"
				validationSchema={issuerSchema}
				optional
				helpElements={
					<div data-tip="React-tooltip" data-for="issuer-info" className="tooltip-info">
						<Icon icon="information-circle--interface-essential" size={12} />
						<ReactTooltip className="tooltip-info" id="issuer-info" effect="solid">
							If your issuer is not in the following template: stytch.com/PROJECT_ID, please provide the correct one
							here
						</ReactTooltip>
					</div>
				}
			/>
		</fieldset>
	)
}
